import { CollectionConfig, TONES } from '../../config/model';
import { ToneKey } from '../../shared/toneColors';
import { BucketEmailStatus } from '../model';

// Mirrors the backend send rules: the location-wide sending_enabled switch overrides every bucket
// (SendScheduledEmailsJob), and a tone with no template counts as off (Collections::Config#enabled_tones).
// Built from TONES, not email_templates, so every bucket gets a status even when its template is missing.
export const buildBucketEmailStatus = (
  config: CollectionConfig | undefined,
): Record<ToneKey, BucketEmailStatus> | undefined => {
  if (!config) return undefined;
  return Object.fromEntries(
    TONES.map((tone) => {
      const template = config.email_templates.find((t) => t.tone === tone);
      let reason = 'Automated emails enabled';
      if (!config.sending_enabled) reason = 'Sending paused for this location';
      else if (!template) reason = 'No email template configured';
      else if (!template.enabled) reason = 'Bucket disabled';
      return [tone, { enabled: !!(config.sending_enabled && template?.enabled), reason }];
    }),
  ) as Record<ToneKey, BucketEmailStatus>;
};
